module.exports = __webpack_public_path__ + "static/media/conffeti-end-game.0bab27da.gif";